console.log('JS Loaded in', Date.now() - window.startLoad)
